import React from 'react';
import { Link } from 'react-router-dom';
import './DlUnitLi.scss';

const AddNew = ({ adr, addStyle }) => {
    let contStyle = {position: 'relative', float: 'left', marginTop: '0em'};
    addStyle = typeof addStyle !== 'undefined' ? addStyle : {};
    contStyle = Object.assign(contStyle, addStyle);

    return <div style={ contStyle }>
        <Link to={{ pathname: adr }} >
            <span style={{marginLeft: '0%'}}>novo</span>
        </Link>
    </div>

} 

export default AddNew;
